const tenantSettings = {
  subheadings: {
    company_settings: 'company settings',
    towpay_integration: 'TowPay integration',
    find_my_car: 'Find My Car',
  },
  helpers: {
    default_rule:
      'select a rule to be assigned automatically to new properties',
    vin_verify:
      'the last {{value}} digits of the VIN required when using plate lookup',
    enable_fmc:
      'enable the Find My Car website for all properties that have not opted out',
    use_tenant_contact:
      'display the public contact information in the details tab instead of the impound yard address on the Find My Car website',
    towpay_integration:
      'support payment throughout the application. Enter Merchant ID to enable.',
    filter_label: 'add custom labels to filter and sort your properties by',
    company_path: 'set a URL path to access a company-branded login page',
    logo_url:
      'URL for the company logo to be displayed on the login and registration pages',
    allow_user_creation_tower_roles:
      'Enable manual role assignment for new users',
    verify_vin_length:
      'Require verification of the last {{value}} characters of the VIN to use the plate lookup feature when creating a job',
    banner_logo_url:
      'URL for the company logo to be displayed in the page header',
    find_my_car_msg:
      'Optional message to be displayed below the contact information on successful search',
    find_my_car_subheading:
      'Allow vehicle owners to search for their vehicle on a public-facing website',
    job_cancellation_subheading:
      'Allow tow cancellation before the job reaches the selected status',
  },
  labels: {
    never: 'Never',
    enroute: 'En Route',
    arrived: 'Arrived',
    hooked: 'Hooked',
  },
};

export default tenantSettings;
